import { render, staticRenderFns } from "./ClientsSideview.vue?vue&type=template&id=f43bf292&scoped=true&class=fill-height&"
import script from "./ClientsSideview.vue?vue&type=script&lang=ts&"
export * from "./ClientsSideview.vue?vue&type=script&lang=ts&"
import style0 from "./ClientsSideview.vue?vue&type=style&index=0&id=f43bf292&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43bf292",
  null
  
)

export default component.exports